"use client";
import React, { useState, useContext, useEffect } from "react";
import { ActivePlan, LoginUpForm,GoogleForm } from "../api/Service";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { ActiveContext } from "../../Context/Context";
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { gapi } from "gapi-script";

function Login({ setIsAuthenticated }) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    showPassword: false,
  });
  const [errors, setErrors] = useState({
    emailError: false,
    passwordError: false,
    passwordNotMatch: null,
  });
  const [loading, setLoading] = useState(false);
  const [Googlerror, setGoogleError] = useState(false)
  const navigate = useNavigate();
  //const { plan, expiryDate, updatePlan, updateDate } = useContext(ActiveContext);
  const clientid = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  // console.log(clientid,'idddddd')


  const notifyError = (message) => {
    toast.error(message || "An error occurred. Please try again.", {
      autoClose: 5000,
      style: {
        background: "#FF7F7F",
        color: "black",
        fontWeight: "bold",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
      },
    });
  };

  const handleSubmit = async (event) => {

    event.preventDefault();
    setErrors({
      emailError: !formData.email,
      passwordError: !formData.password,
      passwordNotMatch: null,
    });

    if (!formData.email || !formData.password) {
      notifyError("Please fill out all required fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await LoginUpForm({ email: formData.email, password: formData.password });
      if (response) {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        const res = await ActivePlan();
        localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName);
        //localStorage.setItem('Subscription', res.data.data.subscriptionStatus);
        //console.log("Active dataa", res.data.data.subscriptionStatus)
        // updatePlan(data.PlanTypeName);
        // updateDate(data.plainEpiryFormatDate);
        navigate("/app/credit-coach");
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Login failed. Please try again.";
      setErrors({ ...errors, passwordNotMatch: errorMessage });
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
    async function wordpress() {
      try {
        const response = await axios.post('https://aicreditrepair.io/wp-json/custom/v1/login', {
          username: formData.email,
          password: formData.password
        }, {
          withCredentials: true  // This enables cookies to be sent and received
        });
      } catch (error) {
        console.error('Error logging into WordPress:', error);
      }
    };
    wordpress()
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleGoogleLoginSuccess = async (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
    console.log(decoded, 'decodedddd')
    let payload = {
      user_email: decoded.email,
      display_name: decoded.name,
      firstName: decoded.given_name,
      lastName: decoded.family_name,
      google_id: decoded.sub

    };
    try {
      const response = await GoogleForm(payload);
      if (response) {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        const res = await ActivePlan();
        localStorage.setItem('PlanTypeName', res.data.data.PlanTypeName);
        navigate("/app/credit-coach",{
          state:{
            openModal: false,
          }
        });
      }
    } catch (error) {
      if(error){
        setGoogleError(true)
        console.error("Error logging in with Google", error);
      }else{
        setGoogleError(false)
      }
    }
  };

  const handleGoogleLoginFailure = () => {
    console.log("Google login failed");
  };

  // useEffect(() => {
  //   function start() {
  //     gapi.client
  //       .init({
  //         clientId: clientid,
  //         scope: "https://www.googleapis.com/auth/userinfo.profile",
  //       })
  //       .then(() => {
  //         console.log("Google API client initialized");
  //       })
  //       .catch((error) => {
  //         console.error("Error initializing Google API client", error);
  //       });
  //   }

  //   if (window.gapi) {
  //     gapi.load("client:auth2", start);
  //   } else {
  //     console.error("gapi is not available");
  //   }
  // }, [clientid]);

  return (
    <div className="flex justify-center items-center min-h-screen bg-[#f5f5f5] p-4 font-sans">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <div className="flex justify-center mb-8">
          <h1 className="text-3xl font-bold text-[#121212]">AI Credit Repair</h1>
        </div>
        <h2 className="text-2xl font-semibold mb-6 text-center">Welcome Back</h2>

        {errors.emailError && (
          <p className="text-sm mt-1 flex justify-start gap-[8px] pl-3 items-center bg-pink-100 h-10">
            Please enter an email
          </p>
        )}
        {errors.passwordError && (
          <p className="text-sm mt-1 flex justify-start gap-[8px] pl-3 items-center bg-pink-100 h-10">
            Please enter Password
          </p>
        )}
        {errors.passwordNotMatch && (
          <p className="text-sm mt-1 flex justify-start gap-[8px] pl-3 items-center bg-pink-100 h-10">
            {errors.passwordNotMatch}
          </p>
        )}
        {Googlerror && (
          <p className="text-sm mt-1 flex justify-start gap-[8px] pl-3 items-center bg-pink-100 h-10">
            Please Try Again
          </p>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              className="w-full p-3 border border-gray-300 rounded"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-4 relative">
            <input
              type={formData.showPassword ? "text" : "password"}
              name="password"
              placeholder="Password*"
              className="w-full p-3 border border-gray-300 rounded"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              name="showPassword"
              id="showPassword"
              className="mr-2"
              checked={formData.showPassword}
              onChange={handleInputChange}
            />
            <label htmlFor="showPassword" className="text-sm text-gray-600">
              Show Password
            </label>
          </div>
          <div className="mb-6 text-left">
            <a onClick={() => navigate('/app/reset-password-email')} className="text-sm text-gray-600 hover:underline cursor-pointer">
              Forgot Password?
            </a>
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-purple-500 to-red-500 text-white rounded-lg font-semibold hover:from-purple-600 hover:to-red-600"
            disabled={loading}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
        <div className="py-1 mt-4 justify-center w-[100%] hidden sm:flex">

        <GoogleOAuthProvider clientId={clientid}>
          <GoogleLogin 
            onSuccess={handleGoogleLoginSuccess}
            onError={handleGoogleLoginFailure}
          />
        </GoogleOAuthProvider>
        </div>

        <div className="mt-3 text-center text-sm">
          <a href="#" className="text-gray-600 hover:underline">
            Do not have account? <Link to="/app/signup">Signup</Link>
          </a>
        </div>
        <div className="mt-4 text-center text-xs text-gray-500">
          <a href="#" className="hover:underline">
            Terms Of Use
          </a>{" "}
          |
          <a href="#" className="hover:underline ml-2">
            Privacy Policy
          </a>{" "}
          |
          <a href="#" className="hover:underline ml-2">
            Do Not Sell or Share My Personal Information
          </a>{" "}
          |
          <a href="#" className="hover:underline ml-2">
            Looking for Truebill?
          </a>
        </div>
      </div>
      <ToastContainer style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
      }} />
    </div>
  );
}

export default Login;